/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { GpsFixed, Wifi, CellTower } from '@mui/icons-material';
import { Box } from '@mui/material';

const IconMap = {
  g: GpsFixed,
  w: Wifi,
  c: CellTower,
};

const NameMap = {
  g: 'GPS',
  w: 'Wi-Fi',
  c: 'Cellular',
};

const CollectionModeIcon = ({ mode }) => {
  const Icon = IconMap[mode];
  if (!Icon) return null;
  return <Icon />;
};

const PositionCollectionMode = forwardRef(
  ({ mode, hideName, ...props }, ref) => {
    return (
      <Box display="flex" gap={1} alignItems="center" ref={ref} {...props}>
        <CollectionModeIcon mode={mode} />
        {!hideName && <span>{NameMap[mode]}</span>}
      </Box>
    );
  },
);

CollectionModeIcon.propTypes = {
  mode: PropTypes.oneOf(['g', 'w', 'c']).isRequired,
};

PositionCollectionMode.propTypes = {
  mode: PropTypes.oneOf(['g', 'w', 'c']).isRequired,
  hideName: PropTypes.bool,
};

export default PositionCollectionMode;
